// 柔佛州球场数据
// Johor Golf Courses

export const JOHOR_COURSES = {
  "AUSTIN_HEIGHTS_GOLF_AND_HOTEL_RESORT": {
    shortName: "AHGHR",
    fullName: "Austin Heights Golf & Hotel Resort",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [4,3,5,4,3,4,5,4,4, 5,4,5,3,4,4,3,4,4],
    index: [5,11,7,17,15,13,1,3,9, 2,4,8,14,6,10,18,16,12]
  },

  "BUKIT_BANANG_GOLF_AND_COUNTRY_CLUB": {
    shortName: "BBGCC",
    fullName: "Bukit Banang Golf & Country Club",
    location: ["Batu Pahat", "Johor", "Malaysia"],
    pars: [4,5,4,4,4,3,5,3,4, 4,5,4,3,4,4,3,5,4],
    index: [5,1,7,17,3,13,15,9,11, 10,8,2,14,16,12,18,6,4]
  },

  "DAIMAN_18_GOLF_CLUB": {
    shortName: "DGC",
    fullName: "Daiman 18 Golf Club",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [4,5,3,4,5,3,4,4,4, 4,5,3,5,4,4,4,3,4],
    index: [13,3,15,5,1,17,11,9,7, 10,2,16,4,12,8,6,18,14]
  },

  "FOREST_CITY_GOLF_RESORT_CLASSIC": {
    shortName: "FCGR-C",
    fullName: "Forest City Golf Resort (Classic Course)",
    location: ["Gelang Patah", "Johor", "Malaysia"],
    pars: [4,5,3,4,4,3,4,5,4, 4,3,4,5,4,4,4,3,5],
    index: [18,2,8,12,14,6,16,4,10, 11,13,3,5,7,9,15,17,1]
  },

  "FOREST_CITY_GOLF_RESORT_LEGACY": {
    shortName: "FCGR-L",
    fullName: "Forest City Golf Resort (Legacy Course)",
    location: ["Gelang Patah", "Johor", "Malaysia"],
    pars: [4,4,5,4,3,4,5,3,4, 4,4,5,3,4,3,5,4,4],
    index: [13,9,5,3,17,15,1,11,7, 8,14,2,16,12,18,4,6,10]
  },

  "HORIZON_HILLS_GOLF_AND_COUNTRY_CLUB": {
    shortName: "HHGCC",
    fullName: "Horizon Hills Golf & Country Club",
    location: ["Iskandar Puteri", "Johor", "Malaysia"],
    pars: [4,5,3,4,4,5,4,3,4, 4,4,3,5,4,4,4,3,5],
    index: [11,1,15,17,13,5,3,9,7, 10,6,14,16,2,8,18,12,4]
  },

  "IMPIAN_EMAS_GOLF_AND_COUNTRY_CLUB": {
    shortName: "IEGCC",
    fullName: "Impian Emas Golf & Country Club",
    location: ["Skudai", "Johor", "Malaysia"],
    pars: [4,5,3,4,4,3,5,4,4],
    index: [8,4,7,5,6,9,1,3,2]
  },

  "IOI_PALM_VILLA_GOLF_AND_COUNTRY_RESORT": {
    shortName: "IPVGCR",
    fullName: "IOI Palm Villa Golf & Country Resort",
    location: ["Kulai", "Johor", "Malaysia"],
    pars: [5,4,3,4,4,4,3,4,5, 4,5,3,4,4,3,4,3,6],
    index: [11,7,17,5,1,3,15,9,13, 4,2,12,8,18,14,6,16,10]
  },

  "JOHOR_GOLF_AND_COUNTRY_CLUB": {
    shortName: "JGCC",
    fullName: "Johor Golf & Country Club",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [4,4,4,3,5,5,4,3,4, 5,4,3,4,5,4,4,4,3],
    index: [5,9,11,17,1,3,15,13,7, 6,18,16,4,10,8,2,12,14]
  },

  "KELAB_GOLF_BATU_PAHAT": {
    shortName: "KGBP",
    fullName: "Kelab Golf Batu Pahat",
    location: ["Batu Pahat", "Johor", "Malaysia"],
    pars: [5,3,4,4,4,3,5,4,4],
    index: [3,8,1,6,7,9,4,5,2]
  },

  "KELAB_GOLF_TANJONG_EMAS": {
    shortName: "KGTE",
    fullName: "Kelab Golf Tanjong Emas",
    location: ["Tanjung Emas", "Johor", "Malaysia"],
    pars: [3,4,4,4,3,4,5,4,4],
    index: [7,5,2,1,9,6,4,8,3]
  },

  "KLUANG_GOLF_CLUB": {
    shortName: "KGC",
    fullName: "Kluang Golf Club",
    location: ["Kluang", "Johor", "Malaysia"],
    pars: [3,5,3,4,5,4,3,4,4],
    index: [15,5,11,7,1,13,17,3,9]
  },

  "KUKUP_GOLF_RESORT": {
    shortName: "KGR",
    fullName: "Kukup Golf Resort",
    location: ["Kukup", "Johor", "Malaysia"],
    pars: [4,4,5,4,3,4,4,3,5, 5,4,4,3,4,4,3,4,5],
    index: [5,15,13,1,11,9,7,17,3, 10,14,18,12,4,6,16,2,8]
  },

  "THE_LEGENDS_GOLF_AND_COUNTRY_RESORT": {
    shortName: "LGCR",
    fullName: "The Legends Golf & Country Resort",
    location: ["Kulai", "Johor", "Malaysia"],
    pars: [4,3,4,4,4,5,3,4,4, 4,4,3,4,4,4,5,3,5],
    index: [5,13,7,17,1,11,3,15,9, 14,4,18,8,12,16,6,2,10]
  },

  "OCTVILLE_GOLF_AND_COUNTRY_CLUB": {
    shortName: "OGCR",
    fullName: "Octville Golf & Country Club",
    location: ["Masai", "Johor", "Malaysia"],
    pars: [4,5,4,4,4,3,5,3,4, 4,4,5,3,4,3,5,4,4],
    index: [5,11,3,1,13,15,9,17,7, 16,12,6,18,2,14,8,4,10]
  },

  "ORCHARD_GOLF_AND_COUNTRY_CLUB": {
    shortName: "OGCC",
    fullName: "Orchard Golf And Country Club",
    location: ["Kota Tinggi", "Johor", "Malaysia"],
    pars: [5,4,4,4,3,5,4,3,4, 5,4,4,3,4,4,5,3,4],
    index: [11,1,7,5,17,3,13,9,15, 6,14,2,16,10,12,8,18,4]
  },

  "PALM_RESORT_GOLF_ALLAMANDA": {
    shortName: "PRGCC-A",
    fullName: "Palm Resort Golf & Country Club (Allamanda Course)",
    location: ["Senai", "Johor", "Malaysia"],
    pars: [4,3,5,4,4,4,5,3,4, 4,5,3,4,4,4,5,3,4],
    index: [7,11,15,3,5,13,1,9,17, 10,8,16,6,2,12,14,18,4]
  },

  "PALM_RESORT_GOLF_CEMPAKA": {
    shortName: "PRGCC-C",
    fullName: "Palm Resort Golf & Country Club (Cempaka Course)",
    location: ["Senai", "Johor", "Malaysia"],
    pars: [4,4,3,5,4,3,4,5,4, 4,5,4,4,4,3,4,3,5],
    index: [7,15,17,11,3,13,5,9,1, 8,4,16,14,2,10,6,18,12]
  },

  "PALM_RESORT_GOLF_MELATI": {
    shortName: "PRGCC-M",
    fullName: "Palm Resort Golf & Country Club (Melati Course)",
    location: ["Senai", "Johor", "Malaysia"],
    pars: [4,3,5,4,4,4,3,4,5, 5,4,4,3,4,5,3,4,4],
    index: [13,15,9,5,3,17,11,7,1, 10,4,12,6,14,2,16,18,8]
  },

  "PERMAS_JAYA_GOLF_CLUB": {
    shortName: "PJGC",
    fullName: "Permas Jaya Golf Club",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [4,3,5,4,3,4,5,4,4, 4,3,5,4,3,4,5,4,4],
    index: [3,15,1,5,13,11,9,7,17, 4,16,2,6,14,12,10,8,18]
  },

  "PONDEROSA_GOLF_AND_COUNTRY_CLUB": {
    shortName: "PGCC",
    fullName: "Ponderosa Golf & Country Club",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [4,3,4,4,4,5,3,4,5, 4,5,3,4,4,4,4,3,5],
    index: [11,15,17,3,5,13,7,9,1, 16,10,12,4,6,14,2,18,8]
  },

  "PULAI_SPRINGS_RESORT_MELANA": {
    shortName: "PSR-M",
    fullName: "Pulai Springs Resort (Melana Course)",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [5,4,3,4,4,3,4,4,5, 4,4,3,4,3,5,4,5,4],
    index: [17,1,11,5,9,15,7,13,3, 10,2,16,4,18,14,12,6,8]
  },

  "PULAI_SPRINGS_RESORT_PULAI": {
    shortName: "PSR-P",
    fullName: "Pulai Springs Resort (Pulai Course)",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [5,3,4,3,4,4,4,4,5, 4,5,4,3,5,3,4,4,4],
    index: [7,13,3,17,11,5,1,15,9, 14,8,2,16,10,18,12,6,4]
  },

  "SEBANA__GOLF_&_MARINA_RESORT ": {
    shortName: "SGMR",
    fullName: "Sebana Golf & Marina Resort ",
    location: ["Kota Tinggi", "Johor", "Malaysia"],
    pars: [4,4,5,4,3,4,3,5,4, 4,5,4,4,3,4,3,4,5],
    index: [9,1,3,7,17,15,13,11,5, 4,12,16,10,18,2,14,8,6]
  },

  "SEGAMAT_COUNTRY_CLUB": {
    shortName: "SCC",
    fullName: "Segamat Country Club",
    location: ["Segamat", "Johor", "Malaysia"],
    pars: [4,5,4,4,4,4,3,5,3, 4,4,4,5,3,5,3,4,4],
    index: [11,9,3,7,13,1,17,5,15, 8,6,12,2,14,10,18,4,16]
  },

  "SENIBONG_GOLF_CLUB": {
    shortName: "SGC",
    fullName: "Senibong Golf Club",
    location: ["Johor Bahru", "Johor", "Malaysia"],
    pars: [4,3,4,4,3,4,5,3,5, 4,4,4,4,5,5,4,4,3],
    index: [5,11,17,1,15,13,7,9,3, 12,18,16,2,6,8,4,10,14]
  },

  "STARHILL_GOLF_AND_COUNTRY_CLUB_BINTANG": {
    shortName: "StGCC-Bi",
    fullName: "Starhill Golf & Country Club (Bintang Course)",
    location: ["Kempas Lama", "Johor", "Malaysia"],
    pars: [4,5,4,3,5,4,3,4,4, 4,5,3,4,4,4,3,4,5],
    index: [15,11,3,13,7,17,5,1,9, 12,6,18,4,10,14,16,2,8]
  },

  "STARHILL_GOLF_AND_COUNTRY_CLUB_BUKIT": {
    shortName: "StGCC-B",
    fullName: "Starhill Golf & Country Club (Bukit Course)",
    location: ["Kempas Lama", "Johor", "Malaysia"],
    pars: [4,5,4,3,4,4,3,5,4, 4,5,3,4,5,3,4,4,4],
    index: [17,9,13,15,3,7,11,5,1, 18,8,14,4,10,16,12,6,2]
  },

  "TANJONG_PUTERI_GOLF_RESORT_VILLAGE": {
    shortName: "TPGR-V",
    fullName: "Tanjong Puteri Golf Resort (Village)",
    location: ["Pasir Gudang", "Johor", "Malaysia"],
    pars: [4,4,5,4,3,4,4,3,5, 5,4,4,3,5,4,3,4,4],
    index: [3,9,11,7,15,1,5,17,13, 6,8,12,16,10,14,18,4,2]
  },

  "TANJONG_PUTERI_GOLF_RESORT_PLANTATION": {
    shortName: "TPGR-P",
    fullName: "Tanjong Puteri Golf Resort (Plantation)",
    location: ["Pasir Gudang", "Johor", "Malaysia"],
    pars: [5,4,4,3,4,4,5,3,4, 4,3,4,4,5,3,4,5,4],
    index: [11,1,7,17,5,15,9,13,3, 12,18,6,14,10,16,2,8,4]
  },

  "TANJONG_PUTERI_GOLF_RESORT_STRAITS": {
    shortName: "TPGR-S",
    fullName: "Tanjong Puteri Golf Resort (Straits)",
    location: ["Pasir Gudang", "Johor", "Malaysia"],
    pars: [5,4,3,4,4,5,4,3,4, 5,4,4,3,4,4,5,3,4],
    index: [11,1,15,9,5,17,3,13,7, 18,6,12,4,10,8,16,14,2]
  },

  "THE_ELS_CLUB_COAST_RIDGE": {
    shortName: "TEC-CR",
    fullName: "The Els Club Desaru Coast (Coast-Ridge)",
    location: ["Bandar Penawar", "Johor", "Malaysia"],
    pars: [4,3,4,4,5,3,4,5,4, 5,4,4,3,5,4,4,3,4],
    index: [9,7,17,11,13,15,3,1,5, 10,8,2,12,18,6,14,16,4]
  },

  "THE_ELS_CLUB_LAKES_COAST": {
    shortName: "TEC-LC",
    fullName: "The Els Club Desaru Coast (Lakes-Coast)",
    location: ["Bandar Penawar", "Johor", "Malaysia"],
    pars: [4,4,3,4,3,4,5,4,4, 4,4,5,4,4,3,4,3,5],
    index: [9,17,7,13,5,15,3,11,1, 10,8,18,12,14,16,4,2,6]
  },
  
  "THE_ELS_CLUB_RIDGE_LAKES": {
    shortName: "TEC-RL",
    fullName: "The Els Club Desaru Coast (Ridge-Lakes)",
    location: ["Bandar Penawar", "Johor", "Malaysia"],
    pars: [4,4,3,4,3,4,5,4,4, 4,4,5,4,4,3,4,3,5],
    index: [9,7,1,11,17,5,13,15,3, 10,18,8,14,6,16,4,12,2]
  }
};

export default JOHOR_COURSES;
